// --- Mostra rata classica a 71 mesi sotto al prezzo ---

function addLoanSimulationInfo() {

  const products = document.querySelectorAll('.grid-product');
  if (!products.length) return;

  function parsePrice(text) {
    if (!text) return 0;
    return parseFloat(
      text
        .replace(/\./g, '')
        .replace(',', '.')
        .replace(/[^\d.]/g, '')
    ) || 0;
  }

  products.forEach(product => {
    const compareAtPrice = product.querySelector('.sale-price');
    const normalPrice = product.querySelector('.grid-product__price');
    const classicInfoEl = product.querySelector('.loan-simulated-price');

    if (!classicInfoEl) return;

    const basePrice = parsePrice(
      compareAtPrice?.innerText || normalPrice?.innerText
    );

    const prezzoTotale = basePrice;

    // DATI FINANZIAMENTO REALI
    const mesi = 84;
    const TAEG = 0.1299;

    const i = Math.pow(1 + TAEG, 1 / 12) - 1;

    const rata =
      prezzoTotale * i /
      (1 - Math.pow(1 + i, -mesi));

    const rataMensile = Math.ceil(rata); // Arrotonda per eccesso

    classicInfoEl.innerHTML = `
      <div>
        Finanziamento da <strong>€${rataMensile} / mese*</strong>
      </div>
    `;
  });
}

addLoanSimulationInfo();
